import { useContext } from "react";
import { useQuery } from "react-query";
import { RobotEnvironmentContext } from "../../contexts/general/RobotEnvironmentContext";
import { buildEndpoint } from "../endpoints";
import { apifetch } from "../robotapi";

const deletePensionDialogueDataUrl = (userId: string) => 
    buildEndpoint(['pensiondata', 'client', userId]);

export const useDeletePensionDialogueData = () => {
    const { userToken } = useContext(RobotEnvironmentContext);
    const query = useQuery(
        ['pensiondelete', userToken],
        async () => {
            if (userToken === undefined)
                return undefined
            return apifetch(deletePensionDialogueDataUrl(userToken), 'DELETE');
    },
    {
        enabled: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false
    });
    return query;
};